// File: src/components/pages/ManageBookings.jsx
// ServiceProvider (Instructor) page - Manage booking-related tasks
// REFACTORED: Now matches Students.jsx layout and structure

import React, { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Calendar } from 'lucide-react';
import InstructorBookingSlots from './InstructorBookingSlots';
import Cancellations from './Cancellations';
import BookForStudents from './BookForStudents';
import CancelForStudents from './CancelForStudents';
import { AUTH0_NAMESPACE } from '../../utils/constants';
import '../../styles/unified.css';

export default function ManageBookings() {
  const { user } = useAuth0();
  const userRoles = user?.[`${AUTH0_NAMESPACE}/roles`] || [];
  
  const isServiceProvider = userRoles.includes('ServiceProvider');

  // Default to 'booking-slots' tab
  const [activeTab, setActiveTab] = useState('booking-slots');

  // Tab configuration matching Students.jsx pattern
  const bookingTabs = [
    { key: 'booking-slots', label: 'Booking Slots', color: '#667eea' },
    { key: 'book-for-students', label: 'Book For Students', color: '#10b981' },
    { key: 'cancel-for-students', label: 'Cancel For Students', color: '#f59e0b' },
    { key: 'cancellations', label: 'Cancellations', color: '#ef4444' }
  ];

  // Access control - only ServiceProvider can access this page
  if (!isServiceProvider) {
    return (
      <div className="access-denied-container">
        <h2>Access Denied</h2>
        <p>This page is only accessible to instructors.</p>
        <p>Please contact your administrator if you believe this is an error.</p>
      </div>
    );
  }

  return (
    <div className="page-container">
      {/* Page Header - Matching Students.jsx structure 
      <div className="page-header">
        <div className="page-header-left">
          <Calendar size={32} className="page-icon" />
          <h1 className="page-title">Bookings</h1>
        </div>
      </div>
      */}

      {/* Status Tabs - Matching Students.jsx structure */}
      <div className="status-tabs">
        {bookingTabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`status-tab ${activeTab === tab.key ? 'active' : ''}`}
            style={{
              '--tab-color': tab.color,
              borderBottomColor: activeTab === tab.key ? tab.color : 'transparent'
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Content Area - Matching Students.jsx structure */}
      <div className="page-content">
        {activeTab === 'booking-slots' && <InstructorBookingSlots />}
        {activeTab === 'cancellations' && <Cancellations />}
        {activeTab === 'book-for-students' && <BookForStudents />}
        {activeTab === 'cancel-for-students' && <CancelForStudents />}
      </div>
    </div>
  );
}